"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initJsonAndBtnsForModal = void 0;
/**
 * Скрипт инициализации кнопок которые будут вызывать модалку и передавать в неё данные из заданного json.
 *
 * 1 На обёртку кнопок ставим id и путь к json:
 *
 * @example: id="reviewBtnsForModal" data-modal-autoinit-json="/reviews.json"
 *
 * 2 На каждую кнопку ставим инициализацию с id данных (в json):
 * @example: data-modal-autoinit-btn-id="{{ id }}"
 *
 * 3 Затем вызывается инициализация:
 * @example:
 * 			const noImgSrc = (document.getElementById('modalReviewUserAvatarNo') as HTMLImageElement).src;
 * 			initBtnsWithDataForModal('btnsWrapperId', 'modalId', [
 * 				{
 * 					id: 'modalReviewUserAvatar',
 * 					key: 'author.image',
 * 					ifNone: noImgSrc,
 * 					what: 'src',
 * 				},
 * 				{
 * 					id: 'modalReviewUserName',
 * 					key: 'author.name',
 * 					what: 'textContent',
 * 				},
 * 				{
 * 					id: 'modalReviewDate',
 * 					key: 'date',
 * 					what: 'datetime',
 * 				},
 * 				{
 * 					id: 'modalReviewDate',
 * 					key: 'date',
 * 					what: 'textContent',
 * 					function: DateFormatter.toFormat_dd_Mmm_Qyy,
 * 				},
 * 				{
 * 					! Для классов (внутри обёртки) подразумевается что количество элементов с данным класом будет равно количеству элементов в получаемом массиве из данных по ключу `key` или из `function`
 * 					class: 'modal-review-star',
 * 					key: 'stars_count',
 * 					what: 'style',
 * 					function: ratingToPercentsStyleStrings,
 * 				},
 * 			]);
 *
 * 4 Данные должны быть подготовлены в JSON (src/scripts/mocking-server.js):
 * 	 ! На dev пути к изображениям поправить `img.url` и `events`
 * @example: import events from '../data/events.json';
 *
 * 	 if (process.env.NODE_ENV === 'development') {
 * 	 	import('miragejs').then(({ Server, Response }) => {
 * 	 		new Server({
 * 	 			routes() {
 * 	 				this.get('/events.json', () => {
 * 	 					const newEvents = events.map(item => {
 * 	 						if (item.img.url) {
 * 	 							item.img.url = item.img.url.replace('@images', 'assets/img');
 * 	 						}
 * 	 						return item;
 * 	 					});
 *
 * 	 					return newEvents;
 * 	 				});
 * 	 			},
 * 	 		});
 * 	 	});
 * 	 }
 */
const initJsonAndBtnsForModal = (btnsWrapperId, modalId, controllers) => {
    try {
        const $btnsWrapper = document.getElementById(btnsWrapperId);
        if ($btnsWrapper) {
            const $btns = $btnsWrapper.querySelectorAll('[data-modal-autoinit-btn-id]');
            if ($btns.length > 0) {
                const $modal = document.getElementById(modalId);
                const $modalNodes = {};
                const urlJson = $btnsWrapper.dataset.modalAutoinitJson;
                let data = null;
                controllers.forEach(controllerItem => {
                    if (controllerItem.id) {
                        $modalNodes[`$${controllerItem.id}`] = document.getElementById(`${controllerItem.id}`);
                    }
                    else if (controllerItem.class) {
                        $modalNodes[`$${controllerItem.class}`] = $modal.getElementsByClassName(`${controllerItem.class}`);
                    }
                });
                $btns.forEach($btn => {
                    $btn.addEventListener('click', function (e) {
                        if (!data) {
                            fetch(urlJson)
                                .then(res => {
                                return res.json();
                            })
                                .then(resData => {
                                data = resData;
                                getModalAndUpdateTrainerDataAtModal($btn, data);
                            });
                        }
                        else {
                            getModalAndUpdateTrainerDataAtModal($btn, data);
                        }
                    });
                });
                function getModalAndUpdateTrainerDataAtModal($btn, data) {
                    const btnId = Number($btn.dataset.modalAutoinitBtnId);
                    controllers.forEach(controllerItem => {
                        let curData = null;
                        console.log(data);
                        if (!controllerItem.key.includes('.')) {
                            curData = data.find(el => Number(el.id) === btnId)[controllerItem.key];
                        }
                        else {
                            let arKeys = controllerItem.key.split('.');
                            curData = data.find(el => Number(el.id) === btnId)[arKeys[0]];
                            if (curData) {
                                for (let i = 1; i < arKeys.length; i++) {
                                    if (curData[arKeys[i]])
                                        curData = curData[arKeys[i]];
                                    else
                                        curData = null;
                                }
                            }
                        }
                        if (curData) {
                            if (controllerItem.function) {
                                curData = controllerItem.function(curData);
                            }
                        }
                        else if (controllerItem.ifNone) {
                            curData = controllerItem.ifNone;
                        }
                        if (controllerItem.id) {
                            const node = $modalNodes[`$${controllerItem.id}`];
                            switch (controllerItem.what) {
                                case 'textContent':
                                    node.textContent = curData;
                                    break;
                                case 'innerHTML':
                                    node.innerHTML = curData;
                                    break;
                                default:
                                    node.setAttribute([controllerItem.what], curData);
                                    break;
                            }
                        }
                        else if (controllerItem.class) {
                            const nodes = $modalNodes[`$${controllerItem.class}`];
                            switch (controllerItem.what) {
                                case 'textContent':
                                    for (let i = 0; i < nodes.length; i++) {
                                        nodes[i].textContent = curData[i];
                                    }
                                    break;
                                case 'innerHTML':
                                    for (let i = 0; i < nodes.length; i++) {
                                        nodes[i].innerHTML = curData[i];
                                    }
                                    break;
                                default:
                                    for (let i = 0; i < nodes.length; i++) {
                                        nodes[i].setAttribute([controllerItem.what], curData[i]);
                                    }
                                    break;
                            }
                        }
                    });
                    let modal = window.modal;
                    modal.open(`#${modalId}`);
                }
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.initJsonAndBtnsForModal = initJsonAndBtnsForModal;
